module.exports = __webpack_public_path__ + "bc5ac4b41ed012e203dfd2dca627fa49.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/BJ.svg
// module id = NYD0
// module chunks = 0